export default "__VITE_ASSET__DQnIfvw8__"